import React, { useEffect } from 'react';
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  activityTypeOptions,
  isCancellationStatus,
  placementStatusOptions,
} from '@AMIEWEB/Placement/NextPlacementStatus/StatusDefaults';
import { selectPlacementStatus } from 'store/redux-store/placement-status/selectors';
import { selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';

export const StartDateReasonCode = ({ options, isModEdit }: { options: any; isModEdit: boolean }) => {
  const { control, getValues, setValue, clearErrors, trigger } = useFormContext();
  const { currentPlacementStatus } = useSelector(selectPlacementStatus);
  const isUndoModal = useSelector(selectIsUndoModal);
  const dispatch = useDispatch();

  const handleStatusCodeChange = value => {
    setValue('startDateReasonCode', value);
    const selectedValue = options?.find(item => item.Description === value);
    setValue('startDateReasonCodeId', selectedValue?.ID ? parseInt(selectedValue?.ID) : '');
    if (value) {
      clearErrors('startDateReasonCode');
    }
  };

  const isRequired = () => {
    if (
      !isModEdit ||
      (currentPlacementStatus.activityTypeId === activityTypeOptions.assignment.activityTypeId &&
        isCancellationStatus(currentPlacementStatus)) ||
      placementStatusOptions.assignmentComplete.activityStatusId === currentPlacementStatus.activityStatusId
    ) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    //TO DO - check this
    trigger('startDateReasonCode');
    const value = options?.find(item => parseInt(item.ID) === getValues('startDateReasonCode'))?.Description;
    setValue('startDateReasonCode', value ?? '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isUndoModal) {
      const value = options?.find(item => parseInt(item.ID) === getValues('startDateReasonCode'))?.Description;
      setValue('startDateReasonCode', value ?? '');
      dispatch(placementModsAction.setIsUndoModal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <>
      <Controller
        control={control}
        name={'startDateReasonCodeId'}
        rules={{ required: isRequired() }}
        render={({ field: { onChange, ...rest } }) => {
          return (
            <FormInputDropdown
              name={'startDateReasonCode'}
              label={isRequired() ? `Start Date Reason Code*` : `Start Date Reason Code`}
              require={isRequired()}
              standard={true}
              options={options ?? []}
              inputValue={getValues('startDateReasonCode') ?? null}
              readOnly={!isModEdit}
              handleChange={e => {
                onChange(e);
                handleStatusCodeChange(e.target.value);
              }}
            ></FormInputDropdown>
          );
        }}
      />
    </>
  );
};
